export enum ReadOnlyWarningType {
    Application = 'application',
    FrnRequest = 'frnRequest',
    Staff = 'staff',
}
